import Footer from "./Footer";
import ContactForm from "./ContactForm";

function ContactSection({ snap=true }) {
  return (
    <div
      className="relative flex flex-col w-full z-20 h-full"
      style={{ scrollSnapAlign: "start" }}
    >
      <div className="flex flex-col flex-grow justify-center items-center bg-brand-kool-blue relative text-white md:py-0 py-10 ">
        <div className="qhd-scale-up">
          <ContactForm />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactSection;
